// greetings.js

export const greet = [
	"😃 Welcome back!",
	"😊 Greetings!",
	"😮 Oh, you're back!",
	"💂 'Ello!",
	"🤠 Howdy!",
	"🧐 Good day sir or madam!",
	"😄 Nice to see you again!",
	"😉 Why, hello there!",
	"😎 Sup.",
	"🙏 Asah my dude.",
	"🏃 Hey, looking productive there!",
	"🌎 What will you accomplish today?",
	"💡 Learn something new? Write it down!",
	"✌️ Your ideas are safe here",
	"🙃",
	"😏 new hyperjot who dis? jk",
	"🐱 meow",
	"🐗 No worries!",
	"🦍 GLPLRBPRLGRPLBLPRB",
	"🥊 Knock out those to-dos!",
];


export const pickGreeting = () => {
	return greet[ Math.floor( Math.random() * greet.length ) ];
}



// WEBPACK FOOTER //
// ./src/greetings.js